import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserProfile } from "../slices/userSlice";
import Loading from "../components/Loading";
import { Route, Routes, useNavigate } from "react-router-dom";

import routes from "../routes";
import Navbar from "../components/Navbar";
import SidebarClient from "../components/SidebarClient";
import NavbarClient from "../components/NavbarClient";

export default function ClientDashboard() {

  const { expanded } = useSelector((state) => state.sidebar);
  const { isDarkMode } = useSelector((state) => state.darkMode);
  const { userInfo, loading, error } = useSelector((state) => state.user);

  const navigate = useNavigate()

  const dispatch = useDispatch()

    useEffect(() => {
        if (isDarkMode) {
          document.documentElement.classList.add("dark");
        } else {
          document.documentElement.classList.remove("dark");
        }
      }, [isDarkMode]);

       useEffect(() => {
          if (!userInfo || !userInfo.email) {
           
            dispatch(getUserProfile());
          }
        }, [dispatch, userInfo]);
      
        if (loading) {
          return <Loading/>
        }
      
        if (error) {
          navigate("/login")
        }

  return (
    <div className="flex h-screen bg-background">

        <SidebarClient userInfo={userInfo} routes={routes} />

        <div
        className={`flex-1 h-full sm:ml-20 ml-0 ${
          expanded ? "sm:ml-64 " : "ml-0"
        } transition-all `}
      >
        <NavbarClient
          routes={routes}
        />

        {/* Main content of the page */}
        <main className=" h-full">
          <Routes>
            {routes[1].pages.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={route.element}
              />
            ))}
            {routes[1].pages[0].subpages.map((subpage) => (
              <Route
                key={subpage.path}
                path={subpage.path}
                element={subpage.element}
              />
            ))}
            
          </Routes>
        </main>
      </div>

    </div>
  )
}
